import { atom } from "recoil";
import { IArchive } from "../generated/Api";

export const UserEmailArchiveAtom = atom<IArchive>({
  key: "UserEmailArchiveAtom",
  default: null,
});
